<template>
    <div>
        <div
            v-if="number > 0"
            class="bg-pink flex justify-center items-center text-white rounded-full w-8 h-8 text-sm"
        >
            {{ number }}
        </div>

        <svg
            v-else
            :width="width" :height="height"
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="11.5" stroke="#F757AF"/>
            <rect x="11.5" y="8" width="1" height="8" fill="#F757AF"/>
            <rect x="8" y="12.5" width="1" height="8" transform="rotate(-90 8 12.5)" fill="#F757AF"/>
        </svg>
    </div>
</template>
<script>
export default {
    name: 'AtomIcFilterAdd',
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        },
        number: {
            type: Number,
            default: 0
        }
    },
}
</script>
